<template>
  <div>
    <div class="review-action-detail">
      <message-card title="审批意见" :isRequire="isRequire">
        <van-field
          v-model="opinionMessage"
          :placeholder="placeholder"
          type="textarea"
        />
      </message-card>
      <message-card>
        <new-file-item v-for="file in fileList" :file="file" :key="file.id"/>
        <div class="add-file" @click="handleAddAttachment">
          <img src="@/assets/embedAppPageImg/add.svg" />
          添加附件
        </div>
      </message-card>
    </div>
    <workflow-form
      :opinionMessage="opinionMessage"
      :currentNodeIndex="this.$props.currentNodeIndex"
      :spStatus="spStatus"
      :workflowInfo="this.$props.workflowInfo"
      :fileList="this.fileList"
    />
  </div>
</template>

<script>
import {i18n} from '@/utils/i18n'
import WorkflowForm from './WorkflowForm'
import MessageCard from '../components/MessageCard'
import { findIndex } from 'lodash'
import config from '@/config'
import NewFileItem from '../components/NewFileItem'
import eventBus from '../utils/eventBus'
import {toast} from '@/utils/common'
import {normalizeFile} from '@/utils/fileUtils'

export default {
  name: 'WorkflowAction',
  i18n,
  components: {
    WorkflowForm,
    MessageCard,
    NewFileItem
  },
  props: {
    workflowInfo: Object,
    currentNodeIndex: Number
  },
  data () {
    return {
      opinionMessage: '',
      placeholder: `请填写审批意见（${this.workflowInputStatus() === 1 ? '必填' : '选填'}）`,
      user_info: config.user_info || {},
      isRequire: this.workflowInputStatus() === 1,
      // eslint-disable-next-line quotes
      fileList: [],
      spStatus: this.workflowInputStatus()
    }
  },
  watch: {
    $route (to, from) {
    }
  },
  computed: {
  },
  mounted () {
    eventBus.addListener('fileFromCloud', this.getAttachmentList)
  },
  methods: {
    handleAddAttachment () {
      if (this.fileList.length >= 10) {
        toast('附件已达上限')
        return
      }
      const data = {
        method: 'fileFromCloud',
        action: 'choose',
        params: { max: 10 }
      }
      console.log('sendData...', data)
      // eslint-disable-next-line no-undef
      fangcloud.postMessage(JSON.stringify(data))
    },
    getAttachmentList (fileList) {
      console.log('getAttachmentList...', fileList)
      const {data} = fileList
      const newFileList = data.map(item => {
        return normalizeFile({...item, extension: item.name.indexOf('.') > -1 ? item.name.split('.')[item.name.split('.').length - 1] : ''}, item.id)
      })
      this.fileList = [...this.fileList, ...newFileList]
    },
    workflowInputStatus () {
      let status = 0
      const { nodes } = this.$props.workflowInfo
      const node = nodes[this.$props.currentNodeIndex]

      const currentItemIndex = findIndex(node.approveUsers, (item) => item.taskStatus === 1 && item.approveUser.id === config.user_info.id)
      const { taskConfig: { comment = '' } } = node.approveUsers[currentItemIndex]

      if (node.needComment && !comment) {
        status = 1
      }
      console.log('status...', status)
      return status
    }
  }
}
</script>
<style lang="postcss">
@import 'variables';

.workflow-action {
  display: flex;
  flex-direction: column;
  padding: 12px 20px;
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  background-color: #F5F8FA;

  & >div {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  & .review-action-detail {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
  }

  & .add-file {
    padding: 16px 0;
    display: flex;
    color: var(--fontBasicColor);
    font-size: 16px;
    line-height:24px;
    & img {
      margin-right: 8px;
    }
  }

}

</style>
